/**
 * Creates a debounced function that counts the number of times it has been called
 * before the timeout expires. The count is passed to the callback function when
 * the timeout completes.
 */
export function createCountedDebounce() {
  const debounceMap: Record<
    string,
    { timer: NodeJS.Timeout | null; count: number }
  > = {}
  /**
   * Creates a debounced function that counts the number of times it has been called
   * before the timeout expires. The count is passed to the callback function when
   * the timeout completes.
   */
  return function countedDebouncePush(
    key: string,
    timeout: number,
    cb: (n: number) => unknown,
    increment = 1
  ) {
    if (debounceMap[key] && debounceMap[key].timer) {
      clearTimeout(debounceMap[key].timer)
    } else {
      debounceMap[key] = { timer: null, count: 0 }
    }

    const timer = setTimeout(() => {
      const count = debounceMap[key].count
      delete debounceMap[key]
      cb(count)
    }, timeout)
    debounceMap[key].timer = timer
    debounceMap[key].count += increment
  }
}
